module.exports = __webpack_public_path__ + "img/email-b.30d815b4.png";